import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import EmailInboxSettings from '../EmailInboxSettings';
import InboxBlocklistSettings from '../InboxBlocklistSettings';
import ForwardingAddresses from '../ForwardingAddresses';

// Shown in place of the Gmail/Outlook connector when the tenant lacks
// `email_inbox_scanning`. Hiding the card outright read as a bug ("why can't I
// connect my mailbox?"), so say that the feature exists and where to get it.
// No price here — the versioned catalog owns pricing; the add-ons card shows it.
const EmailInboxLocked = ({ companyId }) => (
  <div className="modern-card">
    <div className="modern-card-header">
      <div>
        <h2 className="section-title">
          <Mail size={16} /> E-postinkorg
        </h2>
        <p className="section-subtitle">
          Anslut Gmail eller Outlook så hämtas fakturor automatiskt från din inkorg. Ingår i
          tillägget Automatisk fakturainkorg och i Premium. Tills dess kan du vidarebefordra
          fakturor till adressen ovan.
        </p>
      </div>
      <div className="action-buttons">
        <Link to={`/${companyId}/settings/subscription#tillagg`} className="btn btn-primary btn-sm">
          Visa tillägg
        </Link>
      </div>
    </div>
  </div>
);

// E-postinkorg section. Forwarding addresses + manual blocklist are universal;
// the Gmail/Outlook auto-polling connector (EmailInboxSettings) is gated on the
// `email_inbox_scanning` feature, surfaced here via the `showScanning` prop.
const EmailInboxSection = ({ companyId, showScanning }) => (
  <>
    <div id="vidarebefordran">
      <ForwardingAddresses companyId={companyId} />
    </div>
    <div id="koppla-inkorg">
      {showScanning
        ? <EmailInboxSettings companyId={companyId} />
        : <EmailInboxLocked companyId={companyId} />}
    </div>
    <div id="blocklista">
      <InboxBlocklistSettings companyId={companyId} />
    </div>
  </>
);

export default EmailInboxSection;
